import { render, staticRenderFns } from "./aufgaben_abgelehnt.vue?vue&type=template&id=ca4e620c&scoped=true"
import script from "./aufgaben_abgelehnt.vue?vue&type=script&lang=js"
export * from "./aufgaben_abgelehnt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4e620c",
  null
  
)

export default component.exports